<div class="waveform-container">
  @for (bar of waveformBars(); track $index) {
    <div class="waveform-bar" [style.height.%]="bar.height"></div>
  }
</div>
